import { getField, updateField } from 'vuex-map-fields';

import actions from './addFamily/actions';
import getters from './addFamily/getters';
import mutations from './addFamily/mutations';

const state = {
  classId: '',
  clientId: '',
  contactInformation: {},
  dob: '',
  effectiveDate: '',
  eyemedId: '',
  fileBoundId: '',
  firstName: '',
  gender: '',
  groupCk: '',
  groupId: '',
  groupName: '',
  healthIdMatch: false,
  languageAssistance: {},
  lastName: '',
  memberCk: '',
  middleInitial: '',
  planId: '',
  privacyAddress: {
    city: '',
    county: '',
    emailAddress: '',
    firstName: '',
    foreignIndicator: '',
    lastName: '',
    line1: '',
    line2: '',
    line3: '',
    middleInitial: '',
    phoneNumber: '',
    state: '',
    suffix: '',
    zipCode: '',
  },
  reportingCodes: {
    benefitOption: '',
    clientGroupNumber: '',
    companyCode: '',
    divisionCode: '',
    locationCode: '',
    reportingCode1: '',
    reportingCode2: '',
    reportingCode3: '',
    reportingCode4: '',
    reportingCode5: '',
  },
  similarMembers: [],
  ssn: '',
  ssnMatch: false,
  subGroupCk: '',
  subGroupId: '',
  subGroupName: '',
  subscriber: {},
  subscriberId: '',
  subscriberCk: '',
  suffix: '',
  termDate: '',
  transaction: {},
}


export const addFamily = {
  namespaced: true,
  actions,
  getters: {...getters, getField },
  mutations: {...mutations, updateField },
  state,
}
